"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("@emotion/react");

var _Flex = _interopRequireDefault(require("./Flex"));

var _theme = require("../../theme/theme");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Flow = function Flow(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? "div" : _ref$as,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? "start" : _ref$align,
      _ref$justify = _ref.justify,
      justify = _ref$justify === void 0 ? "center" : _ref$justify,
      _ref$space = _ref.space,
      space = _ref$space === void 0 ? '1' : _ref$space,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? false : _ref$wrap;
  return (0, _react2.jsx)(_react2.ClassNames, null, function (_ref2) {
    var css = _ref2.css,
        cx = _ref2.cx;
    return (0, _react2.jsx)(_Flex["default"], {
      as: as,
      align: align,
      justify: justify,
      space: space,
      className: cx(className, css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                flex-direction: row;\n                flex-wrap: ", ";\n              "])), wrap ? "wrap" : "nowrap"))
    }, children);
  });
};

Flow.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  as: _propTypes["default"].string,
  align: _propTypes["default"].oneOf(_theme.FLEX_ALIGN_TYPES),
  justify: _propTypes["default"].oneOf(_theme.FLEX_JUSTIFY_TYPES),
  space: _propTypes["default"].oneOf(_theme.SPACE_TYPES),
  wrap: _propTypes["default"].bool
};
var _default = Flow;
exports["default"] = _default;